
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1V.5a.499.499 0 10-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M5.431 19.692a2 2 0 102.828-2.828 2 2 0 00-2.828 2.828zm.483-5a2 2 0 10-2.828-2.828 2 2 0 002.828 2.828zm7.733-9.961a.498.498 0 00.708 0l1.146-1.146 1.146 1.146a.498.498 0 00.708 0 .5.5 0 000-.707l-1.146-1.146 1.146-1.146a.5.5 0 00-.707-.707l-1.146 1.146-1.146-1.146a.5.5 0 00-.707.707l1.146 1.146-1.146 1.146a.5.5 0 000 .707zm5.5 3a.498.498 0 00.708 0l1.146-1.146 1.146 1.146a.498.498 0 00.708 0 .5.5 0 000-.707l-1.146-1.146 1.146-1.146a.5.5 0 00-.707-.707l-1.146 1.146-1.146-1.146a.5.5 0 00-.707.707l1.146 1.146-1.146 1.146a.5.5 0 000 .707zm-5.608 8.961a2 2 0 10-2.828-2.828 2 2 0 002.828 2.828zm-.078 1.921a2 2 0 102.828 2.828 2 2 0 00-2.828-2.828z"}})])
          )
        }
      }
    